import FeeGroupList from './FeeGroupList';
import FeeGroupCreate from './FeeGroupCreate';
import FeeGroupShow from './FeeGroupShow';

const feeGroups = {
	list: FeeGroupList,
	create: FeeGroupCreate,
	show: FeeGroupShow
};

export default feeGroups;
